module.exports = __webpack_public_path__ + "static/full-power-a4cd528423f22cae028b9d5694bc4257.jpg";